import Clarity from "@microsoft/clarity";

const pendingListings = [];
export const trackClarityListing = (id, mode) => {
  const send = () => {
    window.clarity('set', 'property_id', String(id));
    window.clarity('set', 'property_display_mode', mode);
    window.clarity('event', 'property_viewed');
  };
  if (window.clarity) send();
  else if (process.env.REACT_APP_CLARITY_ID) {
    pendingListings.push(send);
    if (pendingListings.length > 50) pendingListings.shift();
  }
};

// Microsoft Clarity session analytics.
//
// Only runs when REACT_APP_CLARITY_ID is set at build time (.env.production),
// so local dev builds never send anything. The tag is injected after the window
// load event and an idle callback so it stays out of the critical path
// (LCP / TBT). Test and prod share one Clarity project; filter them by the
// "site" tag in the dashboard.
//
// Tag sessions for experiments with: Clarity.setTag("experiment", "variant-b")
const loadClarity = () => {
  const id = process.env.REACT_APP_CLARITY_ID;
  if (!id || typeof window === "undefined" || window.clarity) return;

  const inject = () => {
    Clarity.init(id);
    Clarity.setTag("site", window.location.hostname);
    pendingListings.splice(0).forEach(send => send());
  };

  const schedule = () =>
    "requestIdleCallback" in window
      ? window.requestIdleCallback(inject, { timeout: 5000 })
      : setTimeout(inject, 2000);

  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
};

export default loadClarity;
